import { LoadingButton } from '@mui/lab';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  Alert,
} from '@mui/material';
import { FC, useState } from 'react';
import { toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import { DeleteIcon } from '../../../vectors/index';
import DeleteIcon2 from '@mui/icons-material/Delete';
import { useUnassignCompany } from '../hooks/useUnassignCompany';

type CompanyUnassignModalProps = {
  handleClose: () => void;
  templateName: string;
  company: any;
};

const CompanyUnassignModal: FC<CompanyUnassignModalProps> = ({
  handleClose,
  templateName,
  company,
}) => {
  const [errorText, setErrorText] = useState('');
  const { unassignCompany, isUnassigningCompany } = useUnassignCompany({
    setErrorText,
  });

  const handleSave = () => {
    const options = {
      onSuccess: (data: { message: string }) => {
        toast.success(data.message);
        handleClose();
      },
    };
    unassignCompany({ company_id: company?.id }, options);
  };

  return (
    <Dialog open onClose={handleClose} maxWidth="xs" fullWidth>
      <DialogTitle>
        <IconButton
          sx={{ position: 'absolute', top: 5, right: 5 }}
          onClick={handleClose}
        >
          <CloseIcon />
        </IconButton>
        <br />
        <DeleteIcon />
        <br />
        <Typography variant="h4">
          Are you sure you would like to Unassign <b>{company.s_name}</b> from{' '}
          <b>{templateName}</b>.
        </Typography>
      </DialogTitle>
      <DialogContent>
        {errorText && <Alert>{errorText}</Alert>}
        <LoadingButton
          loading={isUnassigningCompany}
          disabled={isUnassigningCompany}
          sx={{ mt: 2, mb: 2 }}
          fullWidth
          startIcon={<DeleteIcon2 />}
          variant="contained"
          color="error"
          onClick={handleSave}
        >
          Unassign
        </LoadingButton>
      </DialogContent>
    </Dialog>
  );
};

export default CompanyUnassignModal;
